'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Action key that carries API call info interpreted by this Redux middleware.
var CALL_API = exports.CALL_API = Symbol('API Middleware');


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/middleware.js
// module id = 2
// module chunks = 0